let currentDate = new Date(),
    day = currentDate.getDate(),
    month = currentDate.getMonth() + 1,
    year = currentDate.getFullYear(),
    dateInit =  month + "/" + day  + "/" + year,
    initDate = dateInit,
    start = initDate,
    end = dateInit,
    op = 0;

$(function () {

    //find IndexMethod polyfill for IE
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function(predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return -1.
                return -1;
            },
            configurable: true,
            writable: true
        });
    }

    function fillStartDateDropdowns(date_m_d_yy) {

        var strFilled;
        strFilled = date_m_d_yy.split("-");

        $(".startmonth").val((strFilled[0]-1)+strFilled[2]);  //put values
        $(".startday").val(strFilled[1]);
    }
    function fillEndDateDropdowns(date_m_d_yy) {

        var strFilled;
        strFilled = date_m_d_yy.split("/");

        $(".endmonth").val((strFilled[0]-1)+strFilled[2]);   //put values
        $(".endday").val(strFilled[1]);
    }

    function showPrice() {
        setTimeout(function(){
            $('#dateCalendar .ui-datepicker-calendar tbody td').each(function () {
                if($(this).hasClass('has-price')) {
                    var results = $(this).attr("class").match(/price-\d+/i);
                    var price = results&&results.length>0?results[0].split('-')[1]:'0';
                    if($.isNumeric(price) && price !== '0') { 
                        $(this).append('<span class="price">$'+price+'</span>');
                    } else {
                        $(this).append('<span class="sold-out">Sold Out</span>');
                    }

                    /* MinLos */
                    var results = $(this).attr("class").match(/min_los-\d+/i);
                    var minlos = results&&results.length>0?results[0].split('-')[1]:'0';
                    if($.isNumeric(minlos) && minlos > 1 ) {
                        $(this).append('<span class="min_los">'+minlos+' min nts</span>');
                    }
                }
            });
        },  0);
        console.log('update prices');
    }

    const months = ["Jan","Feb","March","April","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];

    function changeDateHTML(target, day, month){
        target.html("<span>"+ day + "</span>" + month);
    }

    const CheckIn__selector = $("#checkIn--date"),
        CheckOut__selector = $("#checkOut--date");

    $.post(site_url + "ajax/functions.php", {
        operation: 'getDayPricesFromTravelTripper',
        hotel_id: "FTHMD",
        rate_code: 'BAR',
        portal_id: "foresttrailhotel",
        min_los: 1,
        number_of_months: 12 
    }, function(data) {

        const dataDates = data.dates;
        const dataPrices =  data.prices;
        const dataMinlos =  data.min_los;

        $.datepicker._defaults.dateFormat = "mm/dd/yy";

        $('#dateCalendar').datepicker({
            inline: true,
            numberOfMonths: 1,
            minDate: 0,
            changeMonth: true,
            beforeShowDay: function(date) {
                let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start),
                    endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end),
                    dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;

                if ($.inArray(dmy, dataDates) != -1) {
                    let index = dataDates.findIndex(x =>x==dmy),
                        style = startDate && ((date.getTime() == startDate.getTime())|| (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight " : "";

                    //return [true,' has-price ' + style + 'price-' + dataPrices[index]];
                    return [true,' has-price ' + style + 'price-' + dataPrices[index] + ' min_los-' + dataMinlos[index] ];
                } else {
                    return [true, startDate && ((date.getTime() == startDate.getTime()) || (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight" : ""];
                }
                
                if(date.getTime() == startDate.getTime()){
                    return[true,"startday"];
                } else {
                    if(date.getTime() == endDate.getTime()){
                        return[true,"endday"];
                    } else {
                        if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
                            return[true,"days"];
                        } else {
                            return[true,""];
                        }
                    }
                }
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function (date) {
                // console.log('onSelect', date);
                let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start),
                    departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end),
                    selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

                //DATE SELECTED
                let thisDate = $(this).datepicker('getDate'),
                    day  = thisDate.getDate(),
                    month = months[thisDate.getMonth()];

                if(op == 0){
                    op = 1;
                    start = date;
                    end =  date;  
                } else {
                    op = 0;
                    
                    if(selectedDate <= arrive){
                        end =  start;
                        start = date;  
                    } else {
                        end =  date; 
                    }
                }

                //$("#Checkin3").attr('value', changeFormatDate(start) + '/'+ changeFormatDate(end));
                $("#CheckIn").val( start );
                $("#CheckOut").val( end );
            
                

                $("#Checkin3").removeClass('active');
                $("#Checkin2").removeClass('active');

                showPrice();
            }
        });

        $('#booking-form').on('submit', function(){
            var CheckInAlt = $('#CheckIn').val();
            var CheckOutAtl = $('#CheckOut').val();

            //m[0] d[1] y[2]

            var finalResultIn = CheckInAlt.split('/');
            finalResultIn = finalResultIn[2] + finalResultIn[0]  + finalResultIn[1];
            
            var finalResultOut = CheckOutAtl.split('/');
            finalResultOut = finalResultOut[2] + finalResultOut[0]  + finalResultOut[1];


            //$('#CheckIn').val(finalResult);
            $('#CheckIn-alt').val(finalResultIn);
            $('#CheckOut-alt').val(finalResultOut);
        });

        function changeDates(){
            $("#CheckIn, #CheckIn-alt").val($("#Checkin2").val());
            $("#CheckOut, #CheckOut-alt").val($("#Checkin2").val());
            fillStartDateDropdowns($("#CheckIn, #CheckIn-alt").val() );
            fillEndDateDropdowns( $("#CheckOut, #CheckOut-alt").val());
        }

        showPrice();

    }, "json");

});